export default __webpack_public_path__ + "4fe278e86372b95b00d5c4a762cbaaa6.svg";